export default {
  setGlobalConfig: (toastrConfig, isMobileApp) => {
    toastrConfig.positionClass = 'toast-bottom-right';
    toastrConfig.closeButton = true;
    toastrConfig.onclick = null;
    toastrConfig.timeOut = 0;
    toastrConfig.extendedTimeOut = 0;
    toastrConfig.preventDuplicates = true;
    toastrConfig.tapToDismiss = false;

    if (isMobileApp) {
      toastrConfig.toastClass += ' mobile';
    }
  }
};



// WEBPACK FOOTER //
// ./client/app/common/utils/toastUtils.js